import React from 'react';
import { View, Text, StyleSheet, ScrollView } from 'react-native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { useTranslation } from 'react-i18next';
import { RootStackParamList } from '../types';
import { AppHeader, ScreenLayout, PageTitle } from '../components';
import { Colors, Fonts, Spacing, Typography } from '../constants';
import { useResponsive } from '../utils/responsive';

type Props = NativeStackScreenProps<RootStackParamList, 'PrivacyPolicy'>;

export const PrivacyPolicyScreen: React.FC<Props> = ({ navigation }) => {
  const { t } = useTranslation();
  const { isDesktop } = useResponsive();

  const sections: Array<{ title?: string; body: string }> = [
    { body: t('screens.privacy.intro') },
    { title: t('screens.privacy.dataTitle'), body: t('screens.privacy.dataBody') },
    { title: t('screens.privacy.paymentsTitle'), body: t('screens.privacy.paymentsBody') },
    { title: t('screens.privacy.statsTitle'), body: t('screens.privacy.statsBody') },
    { title: t('screens.privacy.rightsTitle'), body: t('screens.privacy.rightsBody') },
  ];

  return (
    <ScreenLayout maxWidth={800} desktopPadding>
      <View style={styles.container}>
        {!isDesktop && (
          <AppHeader
            navigation={navigation}
            currentScreen="Profile"
            title={t('screens.privacy.title')}
            showBackButton
          />
        )}
        <ScrollView contentContainerStyle={[styles.content, isDesktop && styles.contentDesktop]}>
          {isDesktop && <PageTitle title={t('screens.privacy.title')} onBack={() => navigation.goBack()} />}
          {sections.map((section, i) => (
            <View key={i} style={styles.section}>
              {section.title ? (
                <Text style={[isDesktop ? Typography.section : Typography.sectionMobile, styles.heading]}>{section.title}</Text>
              ) : null}
              <Text style={[styles.body, isDesktop && styles.bodyDesktop, i === 0 && styles.intro]}>
                {section.body}
              </Text>
            </View>
          ))}
        </ScrollView>
      </View>
    </ScreenLayout>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  content: {
    padding: Spacing.base,
    paddingBottom: Spacing['3xl'],
    gap: Spacing.lg,
    maxWidth: 680,
  },
  contentDesktop: {
    padding: 0,
    gap: Spacing.xl,
  },
  section: {
    gap: 6,
  },
  heading: {
    color: Colors.textDark,
  },
  body: {
    fontFamily: Fonts.regular,
    fontSize: 15,
    lineHeight: 24,
    color: Colors.textMedium,
  },
  bodyDesktop: {
    fontSize: 16,
    lineHeight: 26,
  },
  intro: {
    color: Colors.textDark,
  },
});
